import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const scrollTop = (callback?: () => void) => {
  const onScroll = function () {
    if (window.pageYOffset.toFixed() === '0') {
      window.removeEventListener('scroll', onScroll);
      callback && callback();
    }
  };

  window.addEventListener('scroll', onScroll);
  onScroll();
  window.scrollTo({
    top: 0,
    left: 0,
  });
};

export const ScrollToTopOnMount = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, []);

  return null;
};

export const ScrollToTopOnChange = (callback?: () => void) => {
  const { pathname } = useLocation();

  useEffect(() => {
    scrollTop(callback);
  }, [pathname, callback]);

  return null;
};
